import { useRef } from 'react';

import '../../styles/ui/SpotlightCard.scss';

/**
 * Glass card with a glow that follows the cursor; optional subtle 3D tilt.
 * Extra props are spread onto the root element.
 */
export default function SpotlightCard({ as: Tag = 'div', tilt = false, className = '', children, ...rest }) {
  const ref = useRef(null);

  const onMouseMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const x = e.clientX - r.left;
    const y = e.clientY - r.top;
    el.style.setProperty('--mx', `${x}px`);
    el.style.setProperty('--my', `${y}px`);
    if (tilt) {
      el.style.setProperty('--tx', `${((y / r.height) - 0.5) * -6}deg`);
      el.style.setProperty('--ty', `${((x / r.width) - 0.5) * 6}deg`);
    }
  };

  const onMouseLeave = () => {
    const el = ref.current;
    if (!el || !tilt) return;
    el.style.setProperty('--tx', '0deg');
    el.style.setProperty('--ty', '0deg');
  };

  return (
    <Tag
      ref={ref}
      className={`spotlight-card${tilt ? ' spotlight-card--tilt' : ''}${className ? ` ${className}` : ''}`}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
      {...rest}
    >
      {children}
    </Tag>
  );
}
